import React                    from 'react';
import classnames               from 'classnames';
import { Observe }              from 'rewire-core';
import { WithStyle }            from 'rewire-ui';
import { withStyles }           from '../utility/styles';
import { Theme }                from '@material-ui/core/styles';
import Typography               from '@material-ui/core/Typography';
import auditLogItemViewModel    from './AuditLogItemViewModel';
import { Grid }                 from 'rewire-grid';
import Loader                   from '../ui/Loader';

const styles = (_theme: Theme) => ({
  root: {
    display: 'flex',
    flex: '1',
    width: '100%',
    padding: '5px 0px 0px 0px',
    overflow: 'auto',
  },
  itemContainer: {
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
  },
  noEntries: {
    margin: 'auto',
  },
  headingRow: {
    display: 'flex',
    gap: '10px',
    marginBottom: '10px',
    alignItems: 'flex-start',
  },
  headingTitle: {
    fontWeight: '700',
    minWidth: '100px',
    fontSize: '16px',
    marginBottom: '0px',
  },
  gridContainer: {
    marginTop: '25px',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  secondaryGridContainer: {
    flex: '1',
  },
  loaderContainer: {
    width: '100%',
    minHeight: '0px',
    flex: '1',
  },
  secondaryGridTitle: {
    textAlign: 'center',
    marginBottom: '2px',
  },
});

export interface IAuditLogItemViewProps {
}

export type AuditLogItemViewProps = WithStyle<ReturnType<typeof styles>, IAuditLogItemViewProps>;

class AuditLogDialog extends React.PureComponent<AuditLogItemViewProps> {
  constructor(props: AuditLogItemViewProps) {
    super(props);
  }

  render() {
    const { classes } = this.props;

    return <Observe render={() => (
      <div className={classes.root}>
        <Loader loading={auditLogItemViewModel.isLoading} classes={{root: classes.loaderContainer}}>
          <Observe render={() => (
            !auditLogItemViewModel.selectedAuditLog
              ? <Typography variant='h4' className={classes.noEntries}>No Audit Log Selected</Typography>
              : <div className={classes.itemContainer}>
                  <div className={classes.headingRow}>
                    <Typography variant='body1' className={classes.headingTitle}>Created Date:</Typography>
                    <Typography variant='body1'>{auditLogItemViewModel.selectedAuditLogCreatedDate}</Typography>
                  </div>
                  <div className={classes.headingRow}>
                    <Typography variant='body1' className={classes.headingTitle}>Created By:</Typography>
                    <Typography variant='body1'>{auditLogItemViewModel.selectedAuditLogCreatedBy}</Typography>
                  </div>
                  <div className={classes.headingRow}>
                    <Typography variant='body1' className={classes.headingTitle}>Type:</Typography>
                    <Typography variant='body1'>{auditLogItemViewModel.selectedAuditLogType}</Typography>
                  </div>
                  <div className={classes.headingRow}>
                    <Typography variant='body1' className={classes.headingTitle}>Operation:</Typography>
                    <Typography variant='body1'>{auditLogItemViewModel.selectedAuditLogOperation}</Typography>
                  </div>
                  <div className={classes.headingRow}>
                    <Typography variant='body1' className={classes.headingTitle}>Effective:</Typography>
                    <Typography variant='body1'>{auditLogItemViewModel.selectedAuditLogEffective}</Typography>
                  </div>
                  <div className={classes.headingRow}>
                    <Typography variant='body1' className={classes.headingTitle}>Description:</Typography>
                    <Typography variant='body1'>{auditLogItemViewModel.selectedAuditLogDescription}</Typography>
                  </div>
                  {auditLogItemViewModel.grid
                    ? <div className={classes.gridContainer}>
                        <Grid key={auditLogItemViewModel.selectedAuditLog.id} grid={auditLogItemViewModel.grid} />
                      </div>
                    : null
                  }
                  {auditLogItemViewModel.secondaryGrid
                    ? <div className={classnames(classes.gridContainer, classes.secondaryGridContainer)}>
                        <Typography variant='h6' className={classes.secondaryGridTitle}>{auditLogItemViewModel.secondaryGridTitle}</Typography>
                        <Grid key={auditLogItemViewModel.selectedAuditLog.id} grid={auditLogItemViewModel.secondaryGrid} />
                      </div>
                    : null
                  }
                </div>
          )} />
        </Loader>
      </div> 
    )} />;
  }
}

export default withStyles<IAuditLogItemViewProps>(styles, AuditLogDialog);
